import { render, staticRenderFns } from "./OpportunityListingArchived.vue?vue&type=template&id=fb727904"
import script from "./OpportunityListingArchived.vue?vue&type=script&lang=js"
export * from "./OpportunityListingArchived.vue?vue&type=script&lang=js"
import style0 from "./OpportunityListingArchived.vue?vue&type=style&index=0&id=fb727904&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports